import { FooterConfigProps } from 'components/Footer/Footer.types'
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
export const FooterConfig: FooterConfigProps = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': { height: '82px' }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': { display: 'none' }
    }
  },
  data: {
    leftText: 'Siga O Jornal Daqui:',
    navMenu: [
      {
        id: 'expediente',
        title: 'Expediente',
        href: '/expediente'
      },
      {
        id: 'faleConosco',
        title: 'Fale conosco',
        href: '/fale-conosco',
        target: '_self'
      },
      {
        id: 'anuncieEmJornalDaqui',
        title: 'Anuncie no Jornal Daqui',
        href:  'https://uaiz.opopular.com.br/anuncie-daqui'
      }
    ],
    rightText: `Copyright 2001-${currentYear}, J. Câmara e Irmãos S/A.`,
    socialNetworks: [
      {
        id: 'facebookPage',
        href: 'https://www.facebook.com/meudaqui',
        icon: 'IcBotaoFacebook',
        title: 'Abrir O Daqui no Facebook'
      },
      {
        id: 'twitterPage',
        href: 'https://twitter.com/meudaqui',
        icon: 'IcBotaoTwitter',
        title: 'Abrir O Daqui no Twitter'
      },
    ]
  }
}